import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/pages.css';
import axios from 'axios';

const VideoGallery = () => {
    const [videos, setVideos] = useState([]);

    useEffect(() => {
        const fetchVideos = async () => {
            try {
                const response = await axios.get('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/user_testimonials.php');
                setVideos(response.data);
            } catch (error) {
                console.error('Error fetching videos:', error);
            }
        }; 

        fetchVideos();
    }, []);

    return (
        <div>

            {/* Navbar */}

            <Navbar />

            {/* Navbar Ending */}

            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Patient Testimonials</p>
                    <p className="page-subtitle">
                        
                    </p>

                    <div class="d-none d-md-block"> {/*Visible on desktop, hidden on mobile */}
                        <p className="page-subtitle">
                            Impactful Stories of How Caritas Matha Hospital Has Made a
                            <br /> 
                            Significant Difference in People's Lives.
                        </p>
                    </div>

                    <div class="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                        <p className="page-subtitle">
                            Impactful Stories of How Caritas Matha Hospital Has Made a Significant Difference in People's Lives.
                        </p>
                    </div>
                </div>

                <div className="video-gallery-page">
                    {videos.map(video => (
                        <div key={video.id} className="video-item">
                            <iframe
                                width="100%"
                                height="300"
                                src={`https://www.youtube.com/embed/${video.youtube_id}`}
                                title={video.title}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                            <p className='mb-3'>{video.title}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Footer */}

                <Footer />

            {/* Footer Ending */}

        </div>
    );
};

export default VideoGallery;